import me from './genesys/me';

export default {
  namespaced: true,
  modules: {
    me,
  },
};
